var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeWayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2446 4.5C20.8649 4.5 20.5511 4.78227 20.5015 5.14836L20.4947 5.25014L20.4971 18.2542C20.4971 18.6684 20.833 19.0041 21.2472 19.0041C21.6269 19.0041 21.9406 18.7218 21.9902 18.3557L21.9971 18.2539L21.9947 5.24986C21.9946 4.83565 21.6588 4.5 21.2446 4.5ZM8.35 6.30373L8.27738 6.21961C8.01108 5.95338 7.59442 5.92921 7.30083 6.1471L7.21672 6.21972L2.2201 11.2174C1.95401 11.4835 1.92971 11.8999 2.14727 12.1935L2.21979 12.2776L7.21641 17.2811C7.5091 17.5742 7.98397 17.5745 8.27707 17.2818C8.54352 17.0157 8.56801 16.5991 8.35035 16.3053L8.27779 16.2211L4.5671 12.504L18.2441 12.5049C18.6238 12.5049 18.9376 12.2228 18.9873 11.8567L18.9941 11.7549C18.9941 11.3752 18.712 11.0615 18.3459 11.0118L18.2441 11.0049L4.5541 11.004L8.27749 7.28028C8.54372 7.01398 8.56789 6.59732 8.35 6.30373Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeWayIcon);
export default __webpack_public_path__ + "static/media/trade-way-icon.5040f7931c9e4e21c1af25380707b350.svg";
export { ForwardRef as ReactComponent };